import React, { Fragment } from 'react';
import './featureContent.css';

/**
 * Renders a horizontal workflow chain: Step → Step → Step
 * @param {string[]} steps
 */
function FeatureChain({ steps }) {
    return (
        <div className="fc-chain">
            {steps.map((step, index) => (
                <Fragment key={step}>
                    <div className="fc-chain-step">{step}</div>
                    {index < steps.length - 1 && <span className="fc-chain-arrow">→</span>}
                </Fragment>
            ))}
        </div>
    );
}

export default FeatureChain;
